import { Controller } from "@hotwired/stimulus"

// The More menu is a <details>, so it opens and closes without script and
// resets on every navigation. Script adds the two things a menu is expected
// to do that a disclosure does not: close when the keeper clicks anywhere
// else, and close on Escape. A second menu opening closes the first.
export default class extends Controller {
  connect() {
    this.onPointer = (event) => {
      if (!this.element.open) return
      // A press on the <details> itself is a press on its scrim (::before),
      // which is outside the sheet; anything inside the sheet or summary stays.
      if (event.target !== this.element && this.element.contains(event.target)) return
      this.element.open = false
    }
    this.onKey = (event) => {
      if (event.key !== "Escape" || !this.element.open) return
      this.element.open = false
      this.element.querySelector("summary")?.focus()
    }
    this.onToggle = () => {
      if (!this.element.open) return
      document.querySelectorAll("details[data-controller~='menu'][open]").forEach((other) => {
        if (other !== this.element) other.open = false
      })
    }
    document.addEventListener("pointerdown", this.onPointer)
    document.addEventListener("keydown", this.onKey)
    this.element.addEventListener("toggle", this.onToggle)
  }

  disconnect() {
    document.removeEventListener("pointerdown", this.onPointer)
    document.removeEventListener("keydown", this.onKey)
    this.element.removeEventListener("toggle", this.onToggle)
  }
}
